
import React from 'react';
import LegalDataSection from './sections/LegalDataSection';
import ClassificationSection from './sections/ClassificationSection';
import AddressSection from './sections/AddressSection';
import GeolocationSection from './sections/GeolocationSection';
import ContactSection from './sections/ContactSection';
import OwnerSection from './sections/OwnerSection';

interface GeneralDataFormProps {
  readOnly?: boolean;
}

// Create interface for sections
interface SectionProps {
  readOnly?: boolean;
}

// Make sure each section component accepts the readOnly prop
const GeneralDataForm = ({ readOnly = false }: GeneralDataFormProps) => {
  return (
    <div className="space-y-6">
      <LegalDataSection />
      <ClassificationSection />
      <AddressSection />
      <GeolocationSection />
      <ContactSection />
      <OwnerSection />
    </div>
  );
};

export default GeneralDataForm;
